import React, { Children, FC } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import './DesktopNavbar.css'
import logo from '../../../assets/logo.png'
import svgLogo from '../../../assets/OneLifeLogo_Final.svg'
import { HashLink } from "react-router-hash-link";

interface NavLinkItem {
    name: string;
    path: string;
    children?: NavLinkItem[]
}

interface Props {
    navLinks: NavLinkItem[]
}



const DesktopNavbar: FC<Props> = ({navLinks}) => {

    const navigate = useNavigate()
    const goHome = () => {
        navigate('/')
    }

    return(
        <nav className="desktop navbar">
            <div className="navbar-elements">
                <div className="logo" onClick={goHome}>
                    <img src={svgLogo} alt="Logo" />
                </div>
                <ul className="nav-links">
                    {navLinks.map((link : NavLinkItem) => (
                        <li key={link.path}>
                            <NavLink to={link.path} className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>
                                {link.name}
                                {link.children && <div className="dropdown">
                                    {link.children.map((child: NavLinkItem) => (
                                        <HashLink to={child.path} className="dropdown-link">
                                            {child.name}
                                        </HashLink>
                                    ))}
                                </div>}
                            </NavLink>
                        </li>
                    ))}
                    <li>
                        <button className="application-btn nav-button" onClick={()=>navigate('/loan-application-form')}>Start Application</button>
                    </li>
                    <li>
                        <button className="subscribe-btn nav-button" onClick={()=>navigate('/subscription-agreement-application')}>Subscribe to Us</button>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default DesktopNavbar;